import React, { useEffect } from 'react';

import { Navigate } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';
import { Icon } from '@fnacdarty/back-office-ui';

import { authSSO, isLoggedIn } from '../features/authentication/utils/auth';

const StyledContainer = styled.div`
	height: 100vh;
	width: 100%;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const AuthSSO = () => {
	const theme = useTheme();

	useEffect(() => {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		if (urlParams) {
			const code = urlParams.get('code');
			if (code) {
				authSSO(code).then((response) => {
					if (response) {
						window.location.href = '/';
					} else {
						window.location.href = '/login';
					}
				});
			} else {
				window.location.href = '/login';
			}
		}
	}, []);

	if (isLoggedIn()) {
		return <Navigate to="/" />;
	}
	return (
		<StyledContainer>
			<Icon name={'loader'} width={60} color={theme.colors.primary} />
		</StyledContainer>
	);
};

export default AuthSSO;
